<template>
  <div>
    <Loading v-if="loading" />
    <BaseModal
      :showing="visible"
      overflowable
      @close="$emit('close')"
      @opened="onOpened"
    >
      <BaseCard
        :title="`${id ? 'Edit' : 'Tambah'} Kebijakan Wilayah Penjualan`"
        description="Kebijakan wilayah penjualan"
        :with-style="false"
      >
        <form
          v-if="!loadingEdit"
          class="space-y-4 border-t pt-6"
          @submit.prevent="onSubmit"
        >
          <BaseInput required label="Kode Stockist">
            <OfficeSelectSearch
              fullwidth
              :shadow="false"
              required
              :request-params="{ 'filter[in-office_category_id]': '4' }"
              v-model="form.destinationOffice"
            />
          </BaseInput>

          <BaseInput label="Tipe Kantor Tujuan">
            <div class="flex gap-8">
              <BaseRadio
                label="Pusat"
                val="pusat"
                id="tipe_pusat"
                v-model="form.originOfficeType"
              />
              <BaseRadio
                label="KP"
                val="kp"
                id="tipe_kp"
                v-model="form.originOfficeType"
              />
            </div>
          </BaseInput>

          <BaseInput
            required
            label="Kode Pusat / KP"
            fullwidth
            :shadow="false"
            :disabled="form.originOfficeType === 'pusat'"
            value="PUSAT"
          >
            <OfficeSelectSearch
              v-if="form.originOfficeType === 'kp'"
              fullwidth
              :shadow="false"
              :office-category-id="2"
              required
              v-model="form.originOffice"
            />
          </BaseInput>

          <div class="flex justify-end gap-1">
            <BaseButton color="white" type="button" @click="$emit('close')"
              >Batal</BaseButton
            >
            <BaseButton>Simpan</BaseButton>
          </div>
        </form>
      </BaseCard>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../../../mixins/request/request';
import BaseModal from '../../../base/BaseModal.vue';
import BaseRadio from '../../../base/BaseRadio.vue';
import OfficeSelectSearch from '../../../office/office-select-search.vue';

export default {
  mixins: [requestMixin],
  components: { BaseModal, BaseRadio, OfficeSelectSearch },
  props: {
    id: String,
    visible: Boolean
  },
  emits: ['close', 'saved'],
  data() {
    return {
      pusat: null,
      form: {
        originOfficeType: 'pusat',
        originOffice: null,
        destinationOffice: null
      },
      hideFormModal: true,
      loadingSubmit: false,
      loadingPusat: false,
      loadingEdit: false,
    };
  },
  computed: {
    loading() {
      return this.loadingSubmit || this.loadingEdit;
    },
    originOffice() {
      if (this.form.originOfficeType === 'pusat') {
        return this.pusat.attributes.office_id;
      }

      if (!this.form.originOffice?.id) {
        return null;
      }

      return this.form.originOffice.attributes.office_id;
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadEdit() {
      this.loadingEdit = true;

      const [res, err] = await this.request(`/api/v1/order-destinations/${this.id}`, {
        params: {
          'fields[order-destinations]':
            'origin-office,destination-office',
          'fields[offices]': 'code,name,office_type',
          include: 'origin-office,destination-office',
        },
      });

      if (!err) {
        const originOffice = this.getSingleIncluded(
          res,
          res.data.relationships['origin-office'].data.id
        );
        const destinationOffice = this.getSingleIncluded(
          res,
          res.data.relationships['destination-office'].data.id
        );

        this.form.originOfficeType =
          originOffice.attributes.office_type === 'pusat' ? 'pusat' : 'kp';

        if (this.form.originOfficeType === 'kp') {
          this.form.originOffice = {
            id: originOffice.id,
            attributes: {
              office_id: originOffice.id,
              code: originOffice.attributes.code,
            },
          };
        }

        this.form.destinationOffice = {
          id: destinationOffice.id,
          attributes: {
            office_id: destinationOffice.id,
            code: destinationOffice.attributes.code,
          },
        };
      }

      this.loadingEdit = false;
    },
    async loadPusat() {
      this.loadingPusat = true;

      const [res, err] = await this.request(`/api/v1/offices`, {
        params: {
          'filter[code]': 'pusat',
          'fields[simple-offices]': 'office_id',
        },
      });

      if (!err) {
        this.pusat = res.data[0];
      }

      this.loadingPusat = false;
    },
    async onSubmit() {
      this.loadingSubmit = true;

      const [, err] = await this.request(
        this.id ? `/api/v1/order-destinations/${this.id}` : `/api/v1/order-destinations`,
        {
          method: this.id ? 'patch' : 'post',
          data: {
            data: {
              type: 'order-destinations',
              ...(this.id ? { id: this.id } : {}),
              relationships: {
                'origin-office': {
                  data: this.originOffice
                    ? {
                        type: 'offices',
                        id: this.originOffice,
                      }
                    : null,
                },
                'destination-office': {
                  data: this.form.destinationOffice?.id
                    ? {
                        type: 'offices',
                        id: this.form.destinationOffice.attributes.office_id,
                      }
                    : null,
                }
              },
            },
          },
        }
      );

      if (err) {
        this.createAlert({
          type: 'confirm',
          status: 'error',
          data: this.getRequestErrorMessage(err),
          autoClose: false,
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Data berhasil disimpan',
        });

        this.$emit('close');
        this.$emit('saved');
      }

      this.loadingSubmit = false;
    },
    onOpened() {
      this.form.originOfficeType = 'pusat';
      this.form.originOffice = null;
      this.form.destinationOffice = null;

      if (this.id) {
        this.loadEdit();
      }
    },
  },
  created() {
    this.loadPusat();
  },
};
</script>
